// ManageCodeTable.tsx
import React from "react";
import { BiEditAlt } from "react-icons/bi";
// import "./ManageCodeTable.css";

const EditIcon = BiEditAlt as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export interface CodeRow {
  dateRange: string;
  usage: string;
  usageDotColor: "green" | "orange" | "red" | "gray";
  threshold: number;
  status: "Active" | "Expired" | "Full" | "Inactive";
  editable: boolean;
  icon: React.ReactElement;
  originalData: any;
}

export interface CodeGroup {
  id: string;
  category: string;
  subCategory: string;
  rows: CodeRow[];
}

interface Props {
  groupedData: CodeGroup[];
  onEditClick: (group: CodeGroup, row: CodeRow) => void;
  currentPage: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
}

const ManageCodeTable: React.FC<Props> = ({
  groupedData,
  onEditClick,
  currentPage,
  rowsPerPage,
  onPageChange,
}) => {
  const paginatedData = groupedData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const adminDetail = localStorage.getItem("adminDetail");
  const roleName = adminDetail
    ? JSON.parse(adminDetail)?.roleIds?.roleName
    : null;

  const totalPages = Math.ceil(groupedData.length / rowsPerPage);

  const hasEditableRows = groupedData.some((group) =>
    group.rows.some((row) => row.editable)
  );

  return (
    <>
      <table className="manage-code-table">
        <thead>
          <tr>
            <th>Category Name</th>
            <th>Date Range</th>
            <th>Usage</th>
            <th>Max Allowed</th>
            <th>Threshold</th>
            <th>Status</th>
            {roleName !== "admin" && hasEditableRows && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((group) =>
            group.rows.map((row, index) => (
              <tr key={`${group.id}-${index}`}>
                {index === 0 && (
                  <td rowSpan={group.rows.length}>
                    <div className="manage-code-category">
                      {group.category}
                      <small>{group.subCategory}</small>
                    </div>
                  </td>
                )}
                <td>{row.dateRange}</td>
                <td>
                  {row.usage}
                  <span className={`manage-code-dot ${row.usageDotColor}`} />
                </td>
                <td>{row.originalData.numCoursesAllowed}</td>
                <td>{row.threshold}</td>
                <td>
                  <span
                    className={`manage-code-status ${row.status.toLowerCase()}`}
                  >
                    {row.icon}
                    {row.status}
                  </span>
                </td>
                {roleName !== "admin" && hasEditableRows && (
                  <td>
                    {row.editable && (
                      <EditIcon
                        onClick={() => onEditClick(group, row)}
                        style={{
                          fontSize: 16,
                          color: "#28606B",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="manage-code-pagination">
        <button
          disabled={currentPage === 1 || totalPages === 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <span
            key={i}
            onClick={() => onPageChange(i + 1)}
            className={`manage-code-page-number ${
              currentPage === i + 1 ? "active" : ""
            }`}
          >
            {i + 1}
          </span>
        ))}

        <button
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default ManageCodeTable;
